var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nrk bottom-btn"},[_c('div',{staticClass:"Servic hs"},[_c('p',[_vm._v("吉林医药设计院有限公司专利技术")])]),_c('img',{staticClass:"img-in pc-display",attrs:{"src":"img/js-2.jpg"}}),_c('img',{staticClass:"img-in mobile-display",attrs:{"src":"img/js-4.jpg"}})])
}]

export { render, staticRenderFns }